import Dexie, { type Table } from 'dexie';

/** IndexedDB layout (content-schemas §11.1). Dexie's table version is separate from GameSave.schemaVersion. */
export interface SaveRecord {
  slot: 'main';
  saveId: string;
  schemaVersion: number;
  revision: number;
  updatedAt: number;
  /** fnv1a32 of `json` — corruption detection, not security. */
  checksum: string;
  /** Canonical JSON of the GameSave, stored as a string so the checksum stays stable. */
  json: string;
}

export interface BackupRecord extends Omit<SaveRecord, 'slot'> {
  id?: number;
  slot: 'main';
  reason: 'rolling' | 'pre-migration' | 'pre-import' | 'pre-reset';
  createdAt: number;
}

export interface LedgerEntry {
  txId: string;
  saveId: string;
  atWallMs: number;
  atPlayMs: number;
  kind: 'catalog' | 'stock' | 'sale' | 'order' | 'reward' | 'unlockPayment' | 'mail' | 'minigame';
  coinsDelta: number;
  balanceAfter: number;
  refs: Record<string, string | number>;
}

export interface PhotoRecord {
  id: string;
  saveId: string;
  createdAt: number;
  sceneId: string;
  width: number;
  height: number;
  blob: Blob;
  thumb: Blob;
  frameId?: string;
  stickerIds: string[];
}

/** A track the player added for "Nhạc trong máy". Never part of the save or its export. */
export interface MusicTrackRecord {
  id: string;
  name: string;
  type: string;
  size: number;
  addedAt: number;
  /** The file's bytes (an ArrayBuffer: some WebKit builds cannot store a Blob in IndexedDB). */
  data: ArrayBuffer;
}

export interface KvRecord {
  key: string;
  value: unknown;
}

export class LctDb extends Dexie {
  saves!: Table<SaveRecord, 'main'>;
  backups!: Table<BackupRecord, number>;
  ledger!: Table<LedgerEntry, string>;
  photos!: Table<PhotoRecord, string>;
  kv!: Table<KvRecord, string>;
  music!: Table<MusicTrackRecord, string>;

  constructor(name = 'little-cozy-town') {
    super(name);
    this.version(1).stores({
      saves: 'slot',
      backups: '++id, slot, revision, createdAt, reason',
      ledger: 'txId, saveId, atWallMs, kind',
      photos: 'id, saveId, createdAt',
      kv: 'key',
    });
    this.version(2).stores({ music: 'id, addedAt' });
  }
}
